import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';

export type GenerateApiKeyUseCase = UseCase<void, string>;

export function generateApiKeyBuilder(authRepository: AuthRepository): GenerateApiKeyUseCase {
	return async function generateEmailOtp(): Promise<string> {
		return authRepository.generateApiKey();
	};
}
